module.exports = __webpack_public_path__ + "img/pdf2.edaaa1e1.png";